import { TopsortAdsContext } from './adsAttributionContext';
import { getTopsortProductId } from './getTopsortProductId';
import { sendTopsortEvent } from './sendTopsortEvent';

export const trackAdditionalAttributionClick = ({
  adsContext,
  idBanner,
  item
}: {
  adsContext: TopsortAdsContext;
  idBanner: string;
  item: {
    id: string | number;
    url?: string;
  };
}): void => {
  const productId = getTopsortProductId({
    id: item.id,
    url: item.url
  });

  sendTopsortEvent({
    type: 'click',
    resolvedBidId: adsContext.bidId,
    idBanner,
    additionalAttribution: { id: productId, type: 'product' }
  });
};
